import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { GlobalDataService } from '../services/global-data.service';

@Injectable()
export class LoginService {

  constructor(
  		      private http: HttpClient, 
  		      private global: GlobalDataService
  		      ) { }


  auth(jsData: any){
        return this.http.post(this.global.httpUrl+'login', jsData);
    }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/login/login.service.ts